module.exports = __webpack_public_path__ + "static/media/fogo.71fcd0a2.png";